<template >
  <div>
    <div id="pdfsol" style="width: 21cm !important; padding: 5px;">
		<!-- Equipamentos -->
		<table class="demo" c>
			<thead>
			<tr>
				<th style="text-align: center" colspan="8">
				<h4>{{ $t("equipamento.protocolo") }}</h4>
				</th>
			</tr>
			<tr>
				<th></th>
				<th>
				<strong>{{ $t("chamadoProgramado.desceq") }}</strong>
				</th>
				<th>
				<strong>{{ $t("chamadoProgramado.marca") }}</strong>
				</th>
				<th>
				<strong>{{ $t("chamadoProgramado.modelo") }}</strong>
				</th>
				<th>
				<strong>{{ $t("chamadoProgramado.serie") }}</strong>
				</th>
				<th>
				<strong>{{ $t("chamadoProgramado.tombamento") }}</strong>
				</th>
				<th></th>
			</tr>
			</thead>
			<tbody>
			<tr
				v-for="equipamento in solicitacao.equipamentos"
				:key="equipamento.idequipamento"
			>
				<td></td>
				<td>{{ equipamento.descricao }}</td>
				<td>{{ equipamento.marca }}</td>
				<td>{{ equipamento.modelo }}</td>
				<td>{{ equipamento.serie }}</td>
				<td>{{ equipamento.tombamento }}</td>
				<td></td>
			</tr>
			</tbody>
		</table>
		<!-- Chamado 1 -->
		<table class="demo">
			<thead>
			<tr>
				<th style="text-align: center" colspan="8">
				{{
					solicitacao.interna
					? $t("estoquerelatorios.chamado")
					: $t("sols.solicitacao")
				}}
				#{{ solicitacao.idhotlinesolicitacoes }}
				</th>
			</tr>
			<tr>
				<th></th>
				<th></th>
				<th>{{ $t("global.data") }}</th>
				<th>{{ $t("global.intext") }}</th>
				<th>{{ $t("global.tipo") }}</th>
				<th>{{ $t("global.uh") }}</th>
				<th></th>
				<th></th>
			</tr>
			</thead>
			<tbody>
			<tr>
				<td></td>
				<td></td>
				<td>{{ formatarData(solicitacao.datasolicitacao) }}</td>
				<td>{{ solicitacao.interna ? "OS Interna" : "OS Externa" }}</td>
				<td>{{ solicitacao.tipo }}</td>
				<td>
				{{ solicitacao.coduh.length > 0 ? solicitacao.coduh : "Sem UH" }}
				</td>
				<td></td>
				<td></td>
			</tr>
			</tbody>
		</table>
		<!-- Chamado 2 -->
		<table class="demo">
			<thead>
			<tr>
				<th></th>
				<th></th>
				<th colspan="2">{{ $t("sols.responsavelinterno") }}</th>
				<th colspan="2">{{ $t("sols.prioridade") }}</th>
				<th colspan="2">{{ $t("sols.localatendimento") }}</th>
				<th></th>
				<th></th>
				<th></th>
			</tr>
			</thead>
			<tbody>
			<tr>
				<td></td>
				<td></td>
				<td colspan="2">{{ solicitacao.responsavel }}</td>
				<td colspan="2">
				{{ prioridades[solicitacao.idprioridade].descricao }}
				</td>
				<td colspan="2">{{ solicitacao.localatendimento }}</td>
				<td></td>
				<td></td>
				<td></td>
			</tr>
			</tbody>
		</table>
		<!-- Campos Adicionais -->
		<table class="demo" v-if="dados.camposadicionais.campos.length > 0">
			<thead>
			<tr>
				<th colspan="8" style="text-align: center">Campos Adicionais</th>
			</tr>
			</thead>
			<tbody>
			<tr v-for="campo in dados.camposadicionais.campos" :key="campo.id">
				<td></td>
				<td colspan="2">
					<strong>{{ campo.texto }}</strong>
				</td>
				<td colspan="4">{{ campo.valor }}</td>
				<td></td>
			</tr>
			</tbody>
		</table>
		<!-- Data -->
		<table class="demo">
			<tbody>
				<tr>
					<td colspan="6" style="text-align:center;">{{`De acordo, em ${dataHoje()}.`}}</td>
				</tr>
			</tbody>
		</table>
		<!-- Assinatura e Documento -->
		<table class="demo">
			<thead>
			<tr>
				<th colspan="8" style="text-align: center">
				Assinatura & Documento
				</th>
			</tr>
			</thead>
			<tbody>
			<tr>
				<td colspan="4" style="text-align: center">
				<img
					v-if="dados.imgassinatura.length > 0"
					:src="'data:image/png;base64,' + dados.imgassinatura"
					:id="'imgAss_' + solicitacao.idhotlinesolicitacoes"
					width="200px"
					height="auto"
				/>
				</td>
				<td colspan="4" style="text-align: center">
				<img
					v-if="dados.imgdocumento.length > 0"
					:src="dados.imgdocumento"
					:id="'imgAss_' + solicitacao.idhotlinesolicitacoes"
					width="200px"
					height="auto"
				/>
				</td>
			</tr>
			</tbody>
		</table>
    </div>
	<div style="display: flex; justify-content: center; padding: 1rem">
      <button class="btn-success btn" @click="makePDF()">
        Gerar PDF
        <span class="material-icons icon">download</span>
      </button>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import CONSTANTS from "../constants";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

import moment from "moment";

export default {
  name: "SolicitacaoPDF",
  data() {
    return {
      solicitacao: {},
      setores: [],
      idhotlinesolicitacoes: 0,
      headers: {},
      tipossolicitacao: [],
      responsaveis: [],
      locaisAtendimento: [],
      prioridades: this.$t("sols.prioridades"),
      dados: {},
      imagemSrc: "",
    };
  },
  comments: {},
  methods: {
    makePDF() {
      window.html2canvas = html2canvas;
      var doc = new jsPDF("p", "pt", "a4");
      let el = document.querySelector("#pdfsol");
      doc.html(el, {
        callback: function (pdf) {
          console.error(`Vai salvar o pdf...`);
          pdf.save("FDGuest.pdf");
        },
      });
    },
    carregarLocaisAtendimento() {
      var params = {
        idioma: this.$i18n.locale,
        idhotel: this.$store.getters.GetLoginInfo.idhotel,
      };
      axios
        .post(CONSTANTS.API_URL + "/fdguest/localatendimento/select", params, {
          headers: this.headers,
        })
        .then((response) => {
          if (response.status == 200) {
            this.locaisAtendimento = response.data.dados;
          }
        });
    },
    loadResponsaveis() {
      var searchParams = {
        idioma: this.$i18n.locale,
        idhotel: this.$store.getters.GetLoginInfo.idhotel,
				page: 1,
        pagesize: 1000
      };
      axios
        .post(CONSTANTS.API_URL + "/fdguest/usuarios/tecnicos", searchParams, {
          headers: this.headers,
        })
        .then((response) => {
          try {
            if (response.status == 200) {
              if (response.data.dados) {
                this.responsaveis = response.data.dados;
              }
            } else {
              console.log("Erro:" + JSON.stringify(response));
            }
          } catch (e) {
            console.log(e);
          }
        })
        .catch((err) => {
          console.log({ err_menu: err });
        });
    },
    formatarData(aDate) {
      return moment(aDate).locale(this.$i18n.locale).format("lll");
    },
	dataHoje() 
	{
      return moment().locale(this.$i18n.locale).format("lll");
    },
    hideTexts(id) {
      var obj = document.getElementById("At_" + id);
      if (obj) obj.style.display = "none";
      obj = document.getElementById("At_Produtos_" + id);
      if (obj) obj.style.display = "none";
      obj = document.getElementById("Em_At_Produtos_" + id);
      if (obj) obj.style.display = "none";
      obj = document.getElementById("Em_At_" + id);
      if (obj) obj.style.display = "none";
      obj = document.getElementById("Cancel_" + id);
      if (obj) obj.style.display = "none";
    },

    async loadSolicitacao() {
      const urlParams = new URLSearchParams(window.location.search);

      var params = {
        //idioma: this.$i18n.locale,
        //idhotel: this.$store.getters.GetLoginInfo.idhotel,
        //usuario: this.$store.getters.GetLoginInfo.idusuario,
        idhotlinesolicitacoes: urlParams.get("sol"),
      };
      // console.log(JSON.stringify(params))
      await axios
        .post(
          CONSTANTS.API_URL + "/fdguest/hotlinesolicitacoes/select",
          params,
          { headers: this.headers }
        )
        .then((response) => {
          if (response.status == 200) {
            if (response.data.dados.length > 0) {
              this.solicitacao = response.data.dados[0];
            } else {
              console.log("Solicitação inválida:" + this.idhotlinesolicitacoes);
            }
          } else {
            console.log(JSON.stringify(response));
          }
        });
    },
    async loadDadosAssinar() {
      const urlParams = new URLSearchParams(window.location.search);

      var params = {
        idhotlinesolicitacoes: urlParams.get("sol"),
        idhotlinesolicitacoesassinatura: (this.idhotlinesolicitacoesassinatura =
          urlParams.get("k")),
      };

      await axios
        .post(
          CONSTANTS.API_URL +
            "/fdguest/hotlinesolicitacoes/assinatura/listardadosassinar",
          params,
          { headers: this.headers }
        )
        .then((response) => {
          if (response.status == 200) {
            this.dados = response.data[0];
            if (
              this.dados.imgdocumento == null ||
              !this.dados.imgdocumento.length > 0
            ) {
              this.dados.imgdocumento =
                "data:image/png;base64,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";
            }
            if (this.dados.imgassinatura == null) {
              this.dados.imgassinatura =
                "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";
            }
          } else {
            window.location.href = "/";
          }
        });
    },
    loadUrlParams() {
      const urlParams = new URLSearchParams(window.location.search);
      this.idhotlinesolicitacoes = urlParams.get("sol");
      this.idhotlinesolicitacoesassinatura = urlParams.get("k");
      this.headers = { "x-access-token": urlParams.get("t") };
    },
  },
  mounted() {
    this.loadUrlParams();
    this.loadDadosAssinar();
    //this.loadResponsaveis();
    //this.carregarLocaisAtendimento();
    this.loadSolicitacao();
  },
};
</script>
<style scoped>
.demo {
  border: #c0c0c0;
  border-collapse: collapse;
  padding: 5px;
  width: 15.5cm!important;
}
.demo th {
  border: #c0c0c0;
  padding: 5px;
  background: #f0f0f0;
}
.demo td {
  border: #c0c0c0;
  padding: 5px;
}
</style>